import IconLoader from "@/features/Common/components/IconLoader";
import { convertPxToRem } from "@/utils";

const iconStyles = {
  width: convertPxToRem(36),
  height: convertPxToRem(36),
};

export const PATHOLOGY_PANEL_PILL_MAP: { [key: string]: any } = {
  PATH_VIRAL_LOAD: {
    title: "PathologyPanel.viralLoad.title",
    secondarySubtitle: "PathologyPanel.viralLoad.secondarySubtitle",
    body: "PathologyPanel.viralLoad.body",
    icon: (
      <IconLoader
        icon="HIVBloodDropIcon"
        sx={{ color: "accent4.main", ...iconStyles }}
      />
    ),
  },
  PATH_HBA1C: {
    title: "PathologyPanel.HBA1C.title",
    body: "PathologyPanel.HBA1C.body",
    icon: (
      <IconLoader
        icon="DiabetesCircleIcon"
        sx={{ color: "secondary.dark", ...iconStyles }}
      />
    ),
  },
  PATH_DIABETES: {
    title: "PathologyPanel.diabetesMonitoring.title",
    subtitle: "PathologyPanel.diabetesMonitoring.subtitle",
    secondarySubtitle: "PathologyPanel.diabetesMonitoring.secondarySubtitle",
    body: "PathologyPanel.diabetesMonitoring.body",
    icon: (
      <IconLoader
        icon="DiabetesCircleIcon"
        sx={{ color: "accent3.dark", ...iconStyles }}
      />
    ),
  },
  PATH_ANTENATAL: {
    title: "PathologyPanel.antenatal.title",
    body: "PathologyPanel.antenatal.body",
    icon: (
      <IconLoader
        icon="PregnancyIcon"
        sx={{ color: "accent1.main", ...iconStyles }}
      />
    ),
  },
  PATH_STD_EXCL_HIV: {
    title: "PathologyPanel.stdScreeningExlHiv.title",
    subtitle: "PathologyPanel.stdScreeningExlHiv.subtitle",
    secondarySubtitle: "PathologyPanel.stdScreeningExlHiv.secondarySubtitle",
    body: "PathologyPanel.stdScreeningExlHiv.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "secondary.main", ...iconStyles }}
      />
    ),
  },
  PATH_SYPHILIS: {
    title: "PathologyPanel.syphilis.title",
    body: "PathologyPanel.syphilis.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent2.main", ...iconStyles }}
      />
    ),
  },
  PATH_STD_PCR: {
    title: "PathologyPanel.stdPcr.title",
    body: "PathologyPanel.stdPcr.body",
    icon: <IconLoader icon="SexualTransmittedDiseasesIcon" sx={iconStyles} />,
  },
  PATH_HIV_SCREENING: {
    title: "PathologyPanel.hivScreening.title",
    body: "PathologyPanel.hivScreening.body",
    icon: (
      <IconLoader
        icon="HIVBloodDropIcon"
        sx={{ color: "secondary.main", ...iconStyles }}
      />
    ),
  },
  PATH_HEPATITIS_B: {
    title: "PathologyPanel.hepatitisB.title",
    body: "PathologyPanel.hepatitisB.body",
    icon: (
      <IconLoader
        icon="LiverIcon"
        sx={{ color: "accent5.main", ...iconStyles }}
      />
    ),
  },
  PATH_MALE_OVER_45: {
    title: "PathologyPanel.maleOver45.title",
    subtitle: "PathologyPanel.maleOver45.subtitle",
    secondarySubtitle: "PathologyPanel.maleOver45.secondarySubtitle",
    body: "PathologyPanel.maleOver45.body",
    icon: (
      <IconLoader
        icon="BloodDropsCircleIcon"
        sx={{ color: "accent1.main", ...iconStyles }}
      />
    ),
  },
  PATH_ANAEMIA: {
    title: "PathologyPanel.anaemia.title",
    body: "PathologyPanel.anaemia.body",
    icon: (
      <IconLoader
        icon="BloodDropIcon"
        sx={{ color: "accent4.main", ...iconStyles }}
      />
    ),
  },
  PATH_MALE_UNDER_45: {
    title: "PathologyPanel.maleUnder45.title",
    subtitle: "PathologyPanel.maleUnder45.subtitle",
    secondarySubtitle: "PathologyPanel.maleUnder45.secondarySubtitle",
    body: "PathologyPanel.maleUnder45.body",
    icon: (
      <IconLoader
        icon="BloodDropsCircleIcon"
        sx={{ color: "accent5.main", ...iconStyles }}
      />
    ),
  },
  PATH_HIV_MONITORING: {
    title: "PathologyPanel.hivMonitoring.title",
    subtitle: "PathologyPanel.hivMonitoring.subtitle",
    secondarySubtitle: "PathologyPanel.hivMonitoring.secondarySubtitle",
    body: "PathologyPanel.hivMonitoring.body",
    icon: (
      <IconLoader
        icon="HIVBloodDropIcon"
        sx={{ color: "primary.main", ...iconStyles }}
      />
    ),
  },
  PATH_STD_INCL_HIV: {
    title: "PathologyPanel.stdScreeningInclHiv.title",
    subtitle: "PathologyPanel.stdScreeningInclHiv.subtitle",
    secondarySubtitle: "PathologyPanel.stdScreeningInclHiv.secondarySubtitle",
    body: "PathologyPanel.stdScreeningInclHiv.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent3.main", ...iconStyles }}
      />
    ),
  },
  PATH_FEMALE: {
    title: "PathologyPanel.female.title",
    subtitle: "PathologyPanel.female.subtitle",
    secondarySubtitle: "PathologyPanel.female.secondarySubtitle",
    body: "PathologyPanel.female.body",
    icon: (
      <IconLoader
        icon="BloodDropsCircleIcon"
        sx={{ color: "accent4.main", ...iconStyles }}
      />
    ),
  },
  PATH_CHOLESTEROL: {
    title: "PathologyPanel.cholesterol.title",
    subtitle: "PathologyPanel.cholesterol.subtitle",
    secondarySubtitle: "PathologyPanel.cholesterol.secondarySubtitle",
    body: "PathologyPanel.cholesterol.body",
    icon: (
      <IconLoader
        icon="CholesterolCircleIcon"
        sx={{ color: "accent5.main", ...iconStyles }}
      />
    ),
  },
  PATH_BP: {
    title: "PathologyPanel.bloodPressure.title",
    subtitle: "PathologyPanel.bloodPressure.subtitle",
    secondarySubtitle: "PathologyPanel.bloodPressure.secondarySubtitle",
    body: "PathologyPanel.bloodPressure.body",
    icon: (
      <IconLoader
        icon="BloodPressureCircleIcon"
        sx={{ color: "accent1.main", ...iconStyles }}
      />
    ),
  },
};

export const PATHOLOGY_PANEL_PILL_MAP_V2: { [key: string]: any } = {
  PATH_VIRAL_LOAD: {
    title: "PathologyPanel.viralLoad.title",
    secondarySubtitle: "PathologyPanel.viralLoad.secondarySubtitle",
    body: "PathologyPanel.viralLoad.body",
    icon: (
      <IconLoader
        icon="HIVBloodDropIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_HBA1C: {
    title: "PathologyPanel.HBA1C.title",
    body: "PathologyPanel.HBA1C.body",
    icon: (
      <IconLoader
        icon="DiabetesCircleIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_DIABETES: {
    title: "PathologyPanel.diabetesMonitoring.title",
    subtitle: "PathologyPanel.diabetesMonitoring.subtitle",
    secondarySubtitle: "PathologyPanel.diabetesMonitoring.secondarySubtitle",
    body: "PathologyPanel.diabetesMonitoring.body",
    icon: (
      <IconLoader
        icon="DiabetesCircleIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_ANTENATAL: {
    title: "PathologyPanel.antenatal.title",
    body: "PathologyPanel.antenatal.body",
    icon: (
      <IconLoader
        icon="PregnancyIcon"
        sx={{ color: "primary.main", ...iconStyles }}
      />
    ),
  },
  PATH_STD_EXCL_HIV: {
    title: "PathologyPanel.stdScreeningExlHiv.title",
    subtitle: "PathologyPanel.stdScreeningExlHiv.subtitle",
    secondarySubtitle: "PathologyPanel.stdScreeningExlHiv.secondarySubtitle",
    body: "PathologyPanel.stdScreeningExlHiv.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_SYPHILIS: {
    title: "PathologyPanel.syphilis.title",
    body: "PathologyPanel.syphilis.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_STD_PCR: {
    title: "PathologyPanel.stdPcr.title",
    body: "PathologyPanel.stdPcr.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_HIV_SCREENING: {
    title: "PathologyPanel.hivScreening.title",
    body: "PathologyPanel.hivScreening.body",
    icon: (
      <IconLoader
        icon="HIVBloodDropIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_HEPATITIS_B: {
    title: "PathologyPanel.hepatitisB.title",
    body: "PathologyPanel.hepatitisB.body",
    icon: (
      <IconLoader
        icon="LiverIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_MALE_OVER_45: {
    title: "PathologyPanel.maleOver45.title",
    subtitle: "PathologyPanel.maleOver45.subtitle",
    secondarySubtitle: "PathologyPanel.maleOver45.secondarySubtitle",
    body: "PathologyPanel.maleOver45.body",
    icon: (
      <IconLoader
        icon="BloodDropsCircleIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_ANAEMIA: {
    title: "PathologyPanel.anaemia.title",
    body: "PathologyPanel.anaemia.body",
    icon: (
      <IconLoader
        icon="BloodDropIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_MALE_UNDER_45: {
    title: "PathologyPanel.maleUnder45.title",
    subtitle: "PathologyPanel.maleUnder45.subtitle",
    secondarySubtitle: "PathologyPanel.maleUnder45.secondarySubtitle",
    body: "PathologyPanel.maleUnder45.body",
    icon: (
      <IconLoader
        icon="BloodDropsCircleIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_HIV_MONITORING: {
    title: "PathologyPanel.hivMonitoring.title",
    subtitle: "PathologyPanel.hivMonitoring.subtitle",
    secondarySubtitle: "PathologyPanel.hivMonitoring.secondarySubtitle",
    body: "PathologyPanel.hivMonitoring.body",
    icon: (
      <IconLoader
        icon="HIVBloodDropIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_STD_INCL_HIV: {
    title: "PathologyPanel.stdScreeningInclHiv.title",
    subtitle: "PathologyPanel.stdScreeningInclHiv.subtitle",
    secondarySubtitle: "PathologyPanel.stdScreeningInclHiv.secondarySubtitle",
    body: "PathologyPanel.stdScreeningInclHiv.body",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_FEMALE: {
    title: "PathologyPanel.female.title",
    subtitle: "PathologyPanel.female.subtitle",
    secondarySubtitle: "PathologyPanel.female.secondarySubtitle",
    body: "PathologyPanel.female.body",
    icon: (
      <IconLoader
        icon="BloodDropsCircleIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  PATH_CHOLESTEROL: {
    title: "PathologyPanel.cholesterol.title",
    subtitle: "PathologyPanel.cholesterol.subtitle",
    secondarySubtitle: "PathologyPanel.cholesterol.secondarySubtitle",
    body: "PathologyPanel.cholesterol.body",
    icon: (
      <IconLoader
        icon="CholesterolCircleIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  PATH_BP: {
    title: "PathologyPanel.bloodPressure.title",
    subtitle: "PathologyPanel.bloodPressure.subtitle",
    secondarySubtitle: "PathologyPanel.bloodPressure.secondarySubtitle",
    body: "PathologyPanel.bloodPressure.body",
    icon: (
      <IconLoader
        icon="BloodPressureCircleIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
};

export const PRIMARY_SYMPTOM_PILL_MAP: { [key: string]: any } = {
  SKIN_CONDITIONS: {
    title: "DirectToDoctor.primarySymptoms.skinConditions.title",
    subtitle: "DirectToDoctor.primarySymptoms.skinConditions.subtitle",
    icon: (
      <IconLoader
        icon="SkinConditionsIcon"
        sx={{ color: "accent4.main", ...iconStyles }}
      />
    ),
  },
  EYE_INFECTIONS: {
    title: "DirectToDoctor.primarySymptoms.eyeInfection.title",
    subtitle: "DirectToDoctor.primarySymptoms.eyeInfection.subtitle",
    icon: (
      <IconLoader
        icon="EyeInfectionIcon"
        sx={{ color: "secondary.dark", ...iconStyles }}
      />
    ),
  },
  BLADDER_INFECTION: {
    title: "DirectToDoctor.primarySymptoms.bladderInfection.title",
    subtitle: "DirectToDoctor.primarySymptoms.bladderInfection.subtitle",
    icon: (
      <IconLoader
        sx={{ color: "accent3.main", ...iconStyles }}
        icon="BladderInfectionIcon"
      />
    ),
  },
  COLD_FLU: {
    title: "DirectToDoctor.primarySymptoms.coldFlu.title",
    subtitle: "DirectToDoctor.primarySymptoms.coldFlu.subtitle",
    icon: (
      <IconLoader
        icon="ColdAndFluIcon"
        sx={{ color: "accent5.main", ...iconStyles }}
      />
    ),
  },
  VOMITING_DIARRHEA: {
    title: "DirectToDoctor.primarySymptoms.vomitingDiarrhoea.title",
    subtitle: "DirectToDoctor.primarySymptoms.vomitingDiarrhoea.subtitle",
    icon: (
      <IconLoader
        icon="VomitingAndDiarrhoeaIcon"
        sx={{ color: "accent1.main", ...iconStyles }}
      />
    ),
  },
  HEADACHE: {
    title: "DirectToDoctor.primarySymptoms.headache.title",
    subtitle: "DirectToDoctor.primarySymptoms.headache.subtitle",
    icon: (
      <IconLoader
        icon="HeadacheIcon"
        sx={{ color: "accent2.main", ...iconStyles }}
      />
    ),
  },
  BACK_PAIN: {
    title: "DirectToDoctor.primarySymptoms.backPain.title",
    subtitle: "DirectToDoctor.primarySymptoms.backPain.subtitle",
    icon: (
      <IconLoader
        icon="BackPainIcon"
        sx={{ color: "accent4.main", ...iconStyles }}
      />
    ),
  },
  CONTRACEPTION: {
    title: "DirectToDoctor.primarySymptoms.contraception.title",
    subtitle: "DirectToDoctor.primarySymptoms.contraception.subtitle",
    icon: (
      <IconLoader
        icon="ContraceptionIcon"
        sx={{ color: "secondary.dark", ...iconStyles }}
      />
    ),
  },
  GENITAL_INFECTIONS: {
    title: "DirectToDoctor.primarySymptoms.genitalInfections.title",
    subtitle: "DirectToDoctor.primarySymptoms.genitalInfections.subtitle",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent3.main", ...iconStyles }}
      />
    ),
  },
  GENERAL_CONDITIONS: {
    title: "DirectToDoctor.primarySymptoms.generalConditions.title",
    subtitle: "DirectToDoctor.primarySymptoms.generalConditions.subtitle",
    icon: (
      <IconLoader
        icon="GeneralDoctorConsultIcon"
        sx={{ color: "accent1.main", ...iconStyles }}
      />
    ),
  },
};

export const PRIMARY_SYMPTOM_PILL_MAP_V2: { [key: string]: any } = {
  SKIN_CONDITIONS: {
    title: "DirectToDoctor.primarySymptoms.skinConditions.title",
    subtitle: "DirectToDoctor.primarySymptoms.skinConditions.subtitle",
    icon: (
      <IconLoader
        icon="SkinConditionsIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  EYE_INFECTIONS: {
    title: "DirectToDoctor.primarySymptoms.eyeInfection.title",
    subtitle: "DirectToDoctor.primarySymptoms.eyeInfection.subtitle",
    icon: (
      <IconLoader
        icon="EyeInfectionIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  BLADDER_INFECTION: {
    title: "DirectToDoctor.primarySymptoms.bladderInfection.title",
    subtitle: "DirectToDoctor.primarySymptoms.bladderInfection.subtitle",
    icon: (
      <IconLoader
        sx={{ color: "primary.light", ...iconStyles }}
        icon="BladderInfectionIcon"
      />
    ),
  },
  COLD_FLU: {
    title: "DirectToDoctor.primarySymptoms.coldFlu.title",
    subtitle: "DirectToDoctor.primarySymptoms.coldFlu.subtitle",
    icon: (
      <IconLoader
        icon="ColdAndFluIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  VOMITING_DIARRHEA: {
    title: "DirectToDoctor.primarySymptoms.vomitingDiarrhoea.title",
    subtitle: "DirectToDoctor.primarySymptoms.vomitingDiarrhoea.subtitle",
    icon: (
      <IconLoader
        icon="VomitingAndDiarrhoeaIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  HEADACHE: {
    title: "DirectToDoctor.primarySymptoms.headache.title",
    subtitle: "DirectToDoctor.primarySymptoms.headache.subtitle",
    icon: (
      <IconLoader
        icon="HeadacheIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  BACK_PAIN: {
    title: "DirectToDoctor.primarySymptoms.backPain.title",
    subtitle: "DirectToDoctor.primarySymptoms.backPain.subtitle",
    icon: (
      <IconLoader
        icon="BackPainIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
  CONTRACEPTION: {
    title: "DirectToDoctor.primarySymptoms.contraception.title",
    subtitle: "DirectToDoctor.primarySymptoms.contraception.subtitle",
    icon: (
      <IconLoader
        icon="ContraceptionIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  GENITAL_INFECTIONS: {
    title: "DirectToDoctor.primarySymptoms.genitalInfections.title",
    subtitle: "DirectToDoctor.primarySymptoms.genitalInfections.subtitle",
    icon: (
      <IconLoader
        icon="SexualTransmittedDiseasesIcon"
        sx={{ color: "accent2.dark", ...iconStyles }}
      />
    ),
  },
  GENERAL_CONDITIONS: {
    title: "DirectToDoctor.primarySymptoms.generalConditions.title",
    subtitle: "DirectToDoctor.primarySymptoms.generalConditions.subtitle",
    icon: (
      <IconLoader
        icon="GeneralDoctorConsultIcon"
        sx={{ color: "primary.light", ...iconStyles }}
      />
    ),
  },
};
